import {
  Component,
  ElementRef,
  ViewChild,
  AfterViewInit,
  Renderer2,
} from "@angular/core";

@Component({
  selector: "app-aurea-slider-mobile",
  templateUrl: "./aurea-slider-mobile.component.html",
  styleUrls: ["./aurea-slider-mobile.component.scss"],
})
export class AureaSliderMobileComponent implements AfterViewInit {
  slides = [{ img: "assets/img/aurea/aurea_home_mob.webp" }];

  @ViewChild("animatedBox", { static: false }) animatedBox: ElementRef;

  constructor(private renderer: Renderer2) {}

  ngAfterViewInit() {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // Delay removing class when entering viewport
          setTimeout(() => {
            this.renderer.removeClass(
              this.animatedBox.nativeElement,
              "animate"
            );
          }, 7200);
        } else {
          // Instantly add class back when exiting viewport
          this.renderer.addClass(this.animatedBox.nativeElement, "animated");
        }
      });
    });

    observer.observe(this.animatedBox.nativeElement);
  }
}
